var RegisterCheckinPromptForm = Backbone.Epoxy.View.extend({
  template: 'modals.registerCheckinPromptForm',

  events: {
    'click .js-action__register': 'onRegister',
    'keydown .js-action__register': 'onRegister',
    'click .js-action__cancel': 'onCancel',
    'keydown .js-action__cancel': 'onCancel',
    'submit #registerPromptModalForm': function() { return false; },
    'click .close': 'closeModalManually',
    'keydown .close': 'closeModalManually'
  },

  bindingSources: {
    options: function() {
      return new Backbone.Model({ isConfirmationResent: false });
    }
  },

  /**
   * Boilerplate after render for modals.
   */
  afterRender: function() {
    this.$el.modal({
      show: false
    });

    this.$el.on('hide.bs.modal', function(e) {
      if ('parentIFrame' in window) {
        parentIFrame.sendMessage({event: 'closeModal'});
        $('body').css('background', 'transparent');
      } else {
        console.log('No parent, oh noes')
      }
    });

    this.applyBindings();
  },

  /**
   * Show this form.
   */
  show: function(loginHandler, checkCode, hasCheckin) {
    Backbone.Validation.unbind(this.model);

    this.loginHandler = loginHandler;
    this.checkCode = checkCode;
    this.hasCheckin = hasCheckin;

    this.model.set(this.model.defaults);
  
    if (this.hasCheckin) {
      this.model.set('registerButtonText', "Finish registration and Check In");
      this.model.set('registerButtonProgressText',"Registering and checking in...");
    }
    
    Backbone.Validation.bind(this.model);
    this.$el.modal('show');

    if ('parentIFrame' in window) {
      parentIFrame.sendMessage({event: 'openModal'});
      $('body').css('background', '#fbfbfb');
    } else {
      console.log('No parent, oh noes')
    }

    var el = this.$el;
  },

  closeModal: function() {
    this.model.set('success', true);
    this.model.set('closed', true);
    this.$el.modal('hide');
  },

  closeModalManually: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          this.model.set('success', false);
          this.model.set('closed', true);
          this.$el.modal('hide');
      }
  },

  onCancel: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          this.model.set('accepted', false);
          this.model.set('valid', true);
          this.model.set('password', null);
          this.model.set('confirmPassword', null);
          this.model.set('isProcessing', false);

          this.model.set('validationSuspended', true);

          this.closeModal();
      }
  },

  onRegister: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          this.model.isValid(true);
          if(!this.model.isValid(['password'])){
              this.$el.find('#registerCheckingPasswordInput').attr('aria-invalid', true);
          } else {
              this.$el.find('#registerCheckingPasswordInput').attr('aria-invalid', false);
          }

          if(!this.model.isValid(['confirmPassword'])){
              this.$el.find('#registerCheckingConfirmPasswordInput').attr('aria-invalid', true);
          } else {
              this.$el.find('registerCheckingConfirmPasswordInput').attr('aria-invalid', false);
          }
          
          if (!this.model.isValid(['password', 'confirmPassword']))
              return;

          this.useConfirmCode(this.checkCode, this.hasCheckin);
      }
  },

  onLoginSuccess: function() {
    global.bookedby.helpers.checkInEvent('register');

    this.model.set('accepted', true);
    this.model.set('valid', true);
    this.model.set('password', null);
    this.model.set('confirmPassword', null);
    this.model.set('isProcessing', false);
    this.model.set('hasErrors', false);

    this.model.set('validationSuspended', true);

    this.model.set('validationSuspended', true);

    this.closeModal();
  },

  onLoginFail: function(data) {
    this.model.set('isProcessing', false);
    this.model.set('validationSuspended', true);
    
    if (!data.success) {
      this.model.set('accepted', true);
      this.model.set('valid', false);
      this.model.set('password', null);
      this.model.set('confirmPassword', null);
      this.model.set('hasErrors', true);

      if (data.errorType == "rejection"){
        this.model.set('errorCode', data.errCode);
        this.model.set('errorMessage', data.error);
      } else if (data.errorType == "system") {
        this.model.set('errorCode', "other");
        this.model.set('errorMessage', data.error);
      } else if (data.errorType == "validation") {
        const errString = Object.keys(data.clientValidationErrors).map(function (key) {
          return key + ": " + data.clientValidationErrors[key] + " ";

        })
        this.model.set('errorCode', "other");
        this.model.set('errorMessage', errString);
      } 
      else {
        this.model.set('errorCode', 'other');
        this.model.set('errorMessage', 'There was an error while trying to register. Please try again later.');
      }
    }
  },

  useConfirmCode: function (checkCode, hasCheckin) {
    var password = this.model.get('password');
    var confirmPassword = this.model.get('confirmPassword');
    this.model.set('hasErrors', false);
    this.model.set('isProcessing', true);
    bookedby.app.registerAndCheckin(checkCode, password, confirmPassword, hasCheckin)
    .then(_.bind(function(registerResult){
      this.model.set('isProcessing', false);
      this.onLoginSuccess();
      this.loginHandler(registerResult.loggedInClient, registerResult.checkInData, registerResult.checkInResult);
    },this), _.bind(this.onLoginFail,this));
  }
});

module.exports = RegisterCheckinPromptForm;
